import { motion } from 'framer-motion'
// import { FiArrowRight } from 'react-icons/fi'

const showcases = [
  {
    id: 'dashboard',
    title: 'Dashboard Inteligente',
    description: 'Visualize todas as métricas importantes em um só lugar. Acompanhe o progresso dos projetos, tarefas concluídas, prazos e muito mais.',
    image: '📊',
    reverse: false,
  },
  {
    id: 'kanban',
    title: 'Visualização Kanban',
    description: 'Organize suas tarefas em colunas personalizáveis. Arraste e solte cards para atualizar status rapidamente.',
    image: '📋',
    reverse: true,
  },
  {
    id: 'tasks',
    title: 'Sistema de Tarefas Completo',
    description: 'Crie tarefas e subtarefas hierárquicas com responsáveis, prazos, comentários e muito mais.',
    image: '✅',
    reverse: false,
  },
  {
    id: 'okrs',
    title: 'OKRs e Objetivos',
    description: 'Defina objetivos claros e acompanhe resultados-chave. Alinhe toda a equipe em direção aos mesmos objetivos.',
    image: '🎯',
    reverse: true,
  },
]

export const FeatureShowcase = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="container mx-auto max-w-7xl">
        {showcases.map((showcase) => (
          <motion.div
            key={showcase.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className={`flex flex-col ${showcase.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12 mb-20 last:mb-0`}
          >
            <div className="flex-1">
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                {showcase.title}
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                {showcase.description}
              </p>
              {/* <button className="text-primary-600 hover:text-primary-700 font-medium flex items-center gap-2 group">
                Saiba mais
                <FiArrowRight className="group-hover:translate-x-1 transition-transform" />
              </button> */}
            </div>
            <div className="flex-1">
              <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-200 overflow-hidden">
                <div className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-lg p-12 min-h-[300px] flex items-center justify-center">
                  <div className="text-center">
                    <div className="text-8xl mb-4">{showcase.image}</div>
                    <p className="text-gray-500 font-medium">Preview da funcionalidade</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  )
}

